import useSWRImmutable from "swr/immutable";
import useAuthenticatedAxios from "./use-authenticated-axios";

const EMPTY_IRLS = [];

export default function useIrls() {
  const axios = useAuthenticatedAxios();
  const {
    data: irls,
    error,
    isLoading,
  } = useSWRImmutable("irl", (url) => {
    return axios.get(url).then((res) => res.data);
  });

  return {
    irls: irls || EMPTY_IRLS,
    error,
    isLoading,
  };
}
